import { TextField } from '@mui/material';

/**
 * TextArea Component
 *
 * A reusable multiline text input component with consistent styling
 *
 * @param {string} label - Label for the textarea
 * @param {string} value - Current value
 * @param {function} onChange - Change handler
 * @param {number} rows - Number of rows (default: 4)
 * @param {boolean} required - Whether the field is required
 * @param {string} id - Element ID
 * @param {string} name - Element name
 * @param {string} data-testid - Test ID
 * @param {object} ...rest - Other TextField props
 */
function TextArea({
  label,
  value,
  onChange,
  rows = 4,
  required = false,
  id,
  name,
  'data-testid': dataTestId,
  ...rest
}) {
  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      required={required}
      multiline
      rows={rows}
      fullWidth
      margin="normal"
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        id: id,
        name: name,
        'data-testid': dataTestId,
      }}
      sx={{
        mt: 0,
        mb: 0,
      }}
      {...rest}
    />
  );
}

export default TextArea;
